import { compose } from 'redux'
import { connect } from 'react-redux'
import hasUpdateProgram from '../../hoc/hasUpdateProgram'
import toJS from '../../hoc/toJS'
import config from '../../config.json'
import PageProgramPage from '../../components/PageProgram/PageProgramPage'
import { programFetchRequest } from '../../actions';
import { AUTH_CAPS, PROGRAM_SELECTIONSDISPLAY_ITEMS, PROGRAM_MATCH_CANDIDATES, UI_GENERAL } from '../../constants/state'
import getData from '../../functions/getData'

const mapDispatchToProps = (dispatch, ownProps) => ({
    onFetchProgram: () => {
      dispatch(programFetchRequest())
    }
})

const mapStateToProps = state => ({
    [PROGRAM_SELECTIONSDISPLAY_ITEMS]: getData(state, PROGRAM_SELECTIONSDISPLAY_ITEMS),
    uiRequestOverlayType: getData(state, [UI_GENERAL, 'requestOverlay', 'overlayType']),
    caps: getData(state, AUTH_CAPS),
    showMatchOverlay: getData(state, [PROGRAM_MATCH_CANDIDATES, 'overlayVisible']),
})

const PageProgramPageContainer = ({selectionDisplayItems, caps, goBackPath, onFetchProgram, programStatus, programError, uiRequestOverlayType, showMatchOverlay, onUpdateProgram}) => {
    return <PageProgramPage
        pageTitleTransId={config.routes.program.transId}
        caps={caps}
        closePagePath={goBackPath}
        selectionDisplayItems={selectionDisplayItems}
        onFetchProgram={onFetchProgram}
        programStatus={programStatus}
        programError={programError}
        uiRequestOverlayType={uiRequestOverlayType}
        showMatchOverlay={showMatchOverlay}
        onUpdateProgram={onUpdateProgram}
    />
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    hasUpdateProgram(),
    toJS()
)(PageProgramPageContainer)